import { User } from "models/user-models";
import { applyTheme, buildCustomCssVars } from "theme/themeData";

export { applyTheme, buildCustomCssVars };

export const isAuthenticated = () => {
    return localStorage.getItem('token') !== null;
};

export const saveToken = (token: string) => {
    // const expirationTime = new Date().getTime() + 10 * 24 * 60 * 60 * 1000; // 10 days in milliseconds
    const expirationTime = new Date().getTime() + 1 * 60 * 1000; // 1 minute in millisecond
    localStorage.setItem('token', token);
    localStorage.setItem('expirationTime', JSON.stringify(expirationTime));
};

export const getToken = () => {
    return localStorage.getItem('token');
};

export const saveUser = (user: User) => {
    localStorage.setItem('user', JSON.stringify(user));
    if (user && user.theme) {
        const mode = user.themeMode || "light";
        const savedColors = user.customTheme && ("light" in user.customTheme || "dark" in user.customTheme)
            ? user.customTheme[mode]
            : user.customTheme;
        const customCssVars = user.useCustomTheme && savedColors
            ? buildCustomCssVars(savedColors as Record<string, string>, mode)
            : undefined;
        applyTheme(user.theme, customCssVars, mode);
    }
};

export const getUser = () => {
    const userJSON = localStorage.getItem('user');
    if (!userJSON || userJSON === 'undefined') return null;
    try {
        return JSON.parse(userJSON);
    } catch (e) {
        console.error("Error parsing user from localStorage:", e);
        return null;
    }
};

export const removeToken = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
};
